import React, { forwardRef, useState } from "react";
import { Image, VideoComponent, VideoContainer } from "./Video.styles";
import { useSelector } from "react-redux";
import { selectAutoPlay } from "../../store/slices/common/slice";

const Video = forwardRef(
  (
    { src, imageSrc, className, onClick, controls = false, disabled, autoplay },
    ref,
  ) => {
    const [loaded, setLoaded] = useState(false);

    const handleVideoLoaded = () => {
      setLoaded(true);
    };

    const autoplayEnabled = useSelector(selectAutoPlay);

    return (
      <VideoContainer
        className={className}
        onClick={onClick}
        $cursorPointer={!!onClick && !disabled}
      >
        {!loaded && <Image src={imageSrc} />}
        <VideoComponent
          controls={controls}
          onLoadedData={handleVideoLoaded}
          muted
          loop
          playsInline
          ref={ref}
          autoPlay={autoplay || autoplayEnabled}
          preload="auto"
          style={{ display: loaded ? "block" : "none" }}
        >
          <source src={src} type="video/mp4" />
        </VideoComponent>
      </VideoContainer>
    );
  },
);

export default Video;
